import { HistoryEmptyOrError } from 'src/app/components/HistoryErrorState';
import { selectHistoryError } from 'src/features/historyError';
import {
  Box,
  Button,
  makeStyles,
  TextField,
  withStyles,
  SvgIcon,
  InputAdornment
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Pagination from '@material-ui/lab/Pagination';
import React from 'react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import {
  getLicensePlateQc31,
  resetListLicense
} from '../../../../features/reportBgtQC31Slice';
import {
  reportBusinessLine,
  resetDataScreen,
  exportBusinessLineExcel
} from 'src/features/reportDNSlice';
import { Chip } from '@material-ui/core';
import DateTimeReport from 'src/app/components/input/DateTimeReport';
import { getListSafeZones } from 'src/features/safeZoneSlice';
import { TAT_CA_DON_VI } from '../../../constant/reportFilters';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#F5FAFF',
    color: '#0C1132',
    border: '1px solid #E5E5E8',
    whiteSpace: 'nowrap',
    padding: '12px 16px',
    textAlign: 'center'
  },
  body: {
    fontSize: 14,
    border: '1px solid #E5E5E8',
    color: '#0C1132',
    whiteSpace: 'nowrap',
    padding: '8px 16px',
    textAlign: 'center'
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'white'
    }
  }
}))(TableRow);

const headCells = [
  { id: 'vehicleTypeTitle', label: 'Loại phương tiện' },
  { id: 'licensePlate', label: 'Biển số' },
  { id: 'startAddress', label: 'Địa chỉ đi' },
  { id: 'endAddress', label: 'Địa chỉ đến' },
  { id: 'startTime', label: 'Giờ đi' },
  { id: 'endTime', label: 'Giờ đến' },
  { id: 'activeDuration', label: 'TG hoạt động (giờ:phút)' },
  { id: 'distanceGPS', label: 'Km GPS' },
  { id: 'distanceMechanical', label: 'Km cơ' },
  { id: 'fuelStart', label: 'NL bắt đầu chuyến (lít)' },
  { id: 'fuelEnd', label: 'NL kết thúc chuyến (lít)' },
  { id: 'journeySpeed', label: 'Vận tốc hành trình (km/h)' },
  { id: 'averageSpeed', label: 'Vận tốc trung bình (km/h)' },
  { id: 'fuelConsumed', label: 'NL tiêu thụ' },
  { id: 'fuelNormPerKm', label: 'Định mức NL/km' },
  { id: 'fuelNormTotal', label: 'NL tiêu thụ định mức' },
  { id: 'stopDuration', label: 'Thời gian dừng đỗ (hh:mm)' },
  { id: 'startZoneDuration', label: 'Thời gian trong điểm đi (hh:mm)' },
  { id: 'endZoneDuration', label: 'Thời gian trong điểm đến (hh:mm)' },
  { id: 'completed', label: 'Trạng thái' },
];

const rightAlignedColumns = [
  'distanceGPS',
  'distanceMechanical',
  'journeySpeed',
  'averageSpeed',
  'fuelConsumed',
  'fuelNormPerKm',
  'fuelNormTotal',
  'fuelStart',
  'fuelEnd',
];

const formatTimestampToGmt7 = timestamp => {
  if (timestamp === null || timestamp === undefined || timestamp === '') {
    return '-';
  }

  if (typeof timestamp === 'string' && isNaN(Number(timestamp))) {
    const parsedDate = moment(timestamp);
    return parsedDate.isValid()
      ? parsedDate.utcOffset(7).format('DD/MM/YYYY HH:mm:ss')
      : timestamp;
  }

  const numericTimestamp = Number(timestamp);
  if (Number.isNaN(numericTimestamp)) {
    return timestamp;
  }

  const normalizedTimestamp =
    numericTimestamp < 1000000000000
      ? numericTimestamp * 1000
      : numericTimestamp;

  return moment(normalizedTimestamp)
    .utcOffset(7)
    .format('DD/MM/YYYY HH:mm:ss');
};

const getCellValue = (row, columnId) => {
  const value = row?.[columnId];

  if (columnId === 'startTime' || columnId === 'endTime') {
    return formatTimestampToGmt7(value);
  }

  if (columnId === 'completed') {
    if (typeof value === 'boolean') {
      return value ? 'Hoàn thành' : 'Chưa hoàn thành';
    }
    return value ?? '-';
  }

  return value ?? '-';
};

const EnhancedTableHead = props => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell>STT</StyledTableCell>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              style={{ justifyContent: 'center', width: '100%', display: 'flex', flexDirection: 'row' }}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const BusinessLineReport = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const historyError = useSelector(
    selectHistoryError('reportDNSlice', 'reportBusinessLine')
  );
  const [agencyError, setAgencyError] = useState(false);
  const [licensePlateError, setLicensePlateError] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('startTime');

  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isUser = useSelector(state => state.authSlice.isUser);
  const isDriver = useSelector(state => state.authSlice.isDriver);
  const licensePlateQc = useSelector(state => state.reportSlice.licensePlateQc);
  const listUserQC31 = useSelector(state => state.reportSlice.listUserQC31);
  const businessLineData = useSelector(state => state.reportDNSlice.businessLineData);
  const totalBusinessLine = useSelector(state => state.reportDNSlice.totalBusinessLine);
  const isExporting = useSelector(state => state.reportDNSlice.isExporting);
  const isLoading = useSelector(state => state.reportDNSlice.isLoading);
  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const userId = useSelector(state => state.authSlice.userId);
  const driverId = useSelector(state => state.authSlice.driverId);
  const listSafeZones = useSelector(state => state.safeZoneSlice.listSafeZones);

  //should rename agencyId to userId, but take too much timeee ...
  const [searchObject, setSearchObject] = useState({
    licensePlates: [],
    checkpointZoneIdValue: [],
    agencyId: 0,
    firstTime: moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    }),
    lastTime: moment().set({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999
    }),
    page: 1,
    pageSize: 10
  });

  // Mục "Tất cả đơn vị" chỉ có nghĩa với admin — người dùng thường chỉ thấy đúng đơn vị của mình.
  // Sentinel mang chính id người đang đăng nhập: report API khoanh vùng theo user.id, và với admin
  // id đó phân giải ra toàn bộ xe của hệ thống. Ô biển số bên cạnh vốn đã có "Chọn tất cả".
  const listUser = (userId || driverId)
    ? [dataLogin]
    : isAdmin && listUserQC31 && listUserQC31.length
      ? [{ id: dataLogin?.id, full_name: TAT_CA_DON_VI }, ...listUserQC31]
      : listUserQC31;
  //should rename agencyId to userId, but take too much timeee ...
  const endUserValue = listUser?.find(
    item => item.id === searchObject.agencyId
  );

  // Prepare license plate options with "Select All" option
  const licensePlateOptions = ['Chọn tất cả', ...(licensePlateQc || [])];
  const safeZoneOptions = [
    { id: 'all', nameSafeZone: 'Chọn tất cả' },
    ...(listSafeZones || [])
  ];
  const selectedSafeZoneOptions = (listSafeZones || []).filter(item =>
    (searchObject.checkpointZoneIdValue || []).includes(item.id)
  );

  // Check if all license plates are selected
  const allSelected =
    licensePlateQc &&
    licensePlateQc.length > 0 &&
    searchObject.licensePlates &&
    searchObject.licensePlates.length === licensePlateQc.length;

  const hasSelectedLicensePlates =
    Array.isArray(searchObject.licensePlates) &&
    searchObject.licensePlates.length > 0;

  const allSafeZonesSelected =
    listSafeZones &&
    listSafeZones.length > 0 &&
    searchObject.checkpointZoneIdValue &&
    searchObject.checkpointZoneIdValue.length === listSafeZones.length;

  // Handle select all / deselect all
  const handleSelectAll = () => {
    if (allSelected) {
      // Deselect all
      changeSearchCondition('licensePlates', []);
    } else {
      // Select all
      changeSearchCondition('licensePlates', licensePlateQc || []);
    }
  };

  // Custom onChange to handle "Select All" option
  const handleLicensePlateChange = (e, value) => {
    const hasSelectAll = value.includes('Chọn tất cả');

    if (hasSelectAll) {
      // If currently all are selected, clicking "Select All" will deselect all
      if (allSelected) {
        changeSearchCondition('licensePlates', []);
        return;
      } else {
        // Select all license plates (excluding "Chọn tất cả")
        changeSearchCondition('licensePlates', licensePlateQc || []);
        return;
      }
    }
    changeSearchCondition('licensePlates', value);
  };

  const handleSelectAllSafeZones = () => {
    if (allSafeZonesSelected) {
      changeSearchCondition('checkpointZoneIdValue', []);
    } else {
      changeSearchCondition(
        'checkpointZoneIdValue',
        (listSafeZones || []).map(item => item.id)
      );
    }
  };

  const handleSafeZoneChange = (e, value) => {
    const hasSelectAll = value.some(option => option.id === 'all');

    if (hasSelectAll) {
      handleSelectAllSafeZones();
      return;
    }

    changeSearchCondition(
      'checkpointZoneIdValue',
      value.map(option => option.id)
    );
  };

  useEffect(() => {
    return () => {
      dispatch(resetDataScreen());
    };
  }, []);

  // Auto-fill agency and fetch license plates for end user / driver
  useEffect(() => {
    if ((isUser || isDriver) && dataLogin?.id) {
      setSearchObject(prev => ({
        ...prev,
        agencyId: dataLogin.id
      }));
      dispatch(getLicensePlateQc31({ id: dataLogin.id, business_number: 1 }));
      dispatch(getListSafeZones({
        user_id: dataLogin.id,
        page: 1,
        page_size: 1000,
        keywords: undefined
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUser, isDriver, dataLogin]);

  const changeSearchCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    if (name === 'licensePlates' && value.length > 0) {
      setLicensePlateError(false);
    }
    if (name === 'licensePlates' && (!Array.isArray(value) || value.length === 0)) {
      currentSearchObject.checkpointZoneIdValue = [];
    }
    if (name === 'agencyId') {
      currentSearchObject.agencyId = value.id;
      currentSearchObject.licensePlates = [];
      currentSearchObject.checkpointZoneIdValue = [];
      dispatch(getLicensePlateQc31({ id: value.id, business_number: 1 }));
      dispatch(getListSafeZones({
        user_id: value.id,
        page: 1,
        page_size: 1000,
        keywords: undefined
      }))
    }
    setSearchObject(currentSearchObject);
  };

  const changeDateCondition = (name, value) => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject[name] = value;
    setSearchObject(currentSearchObject);
  };

  const handleClearAgency = () => {
    setSearchObject({
      ...searchObject,
      agencyId: 0,
      licensePlates: [],
      checkpointZoneIdValue: []
    });
    dispatch(resetListLicense());
  };

  const searchFunction = () => {
    if (!searchObject.licensePlates?.length) {
      setLicensePlateError(true);
      return;
    }

    setLicensePlateError(false);
    let currentSearchObject = { ...searchObject };
    currentSearchObject.page = 1;
    currentSearchObject.firstTime = currentSearchObject.firstTime
      ? moment(currentSearchObject.firstTime).unix()
      : null;
    currentSearchObject.lastTime = currentSearchObject.lastTime
      ? moment(currentSearchObject.lastTime).unix()
      : null;
    currentSearchObject.agencyId = currentSearchObject.agencyId
      ? currentSearchObject.agencyId
      : 123456789;
    dispatch(
      reportBusinessLine({
        ...currentSearchObject,
        checkpointZoneId: currentSearchObject.checkpointZoneIdValue || []
      })
    );

    // Update local state to reset to page 1
    setSearchObject(prev => ({
      ...prev,
      page: 1
    }));
  };

  const handlePageChange = pageNumber => {
    let currentSearchObject = { ...searchObject };
    currentSearchObject.page = pageNumber;
    currentSearchObject.firstTime = currentSearchObject.firstTime
      ? moment(currentSearchObject.firstTime).unix()
      : null;
    currentSearchObject.lastTime = currentSearchObject.lastTime
      ? moment(currentSearchObject.lastTime).unix()
      : null;
    currentSearchObject.agencyId = currentSearchObject.agencyId
      ? currentSearchObject.agencyId
      : 123456789;
    dispatch(
      reportBusinessLine({
        ...currentSearchObject,
        checkpointZoneId: currentSearchObject.checkpointZoneIdValue || []
      })
    );

    // Update local state to reflect the page change
    setSearchObject(prev => ({
      ...prev,
      page: pageNumber
    }));
  };

  const downloadFile = () => {
    const params = {
      agencyId: searchObject.agencyId ? searchObject.agencyId : 123456789,
      groupID: searchObject.groupID,
      licensePlates: searchObject.licensePlates || [],
      checkpointZoneId: searchObject.checkpointZoneIdValue || [],
      firstTime: searchObject.firstTime
        ? moment(searchObject.firstTime).unix()
        : '',
      lastTime: searchObject.lastTime
        ? moment(searchObject.lastTime).unix()
        : ''
    };

    dispatch(exportBusinessLineExcel(params))
      .unwrap()
      .then(() => { })
      .catch(error => { });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // Calculate total pages
  const totalPages = Math.ceil(totalBusinessLine / searchObject.pageSize) || 1;

  // Sort data
  const sortedData = React.useMemo(() => {
    if (!businessLineData || businessLineData.length === 0) return [];
    return stableSort(businessLineData, getComparator(order, orderBy));
  }, [businessLineData, order, orderBy]);

  return (
    <Box className={classes.contentContainer}>
      <div className={classes.titleHeader}>Báo cáo tuyến lộ trình</div>
      <div className={classes.searchContainer}>
        <div className={classes.searchRow}>
          <div className={classes.searchItem}>
            <div className={classes.label}>Từ ngày</div>
            <div>
              <DateTimeReport
                className={classes.searchComponent}
                dateTime={searchObject.firstTime}
                onChange={e => changeDateCondition('firstTime', e)}
                format="DD/MM/YYYY HH:mm:ss"
                showTime={{ format: 'HH:mm:ss' }}
              />
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Đến ngày</div>
            <div>
              <DateTimeReport
                className={classes.searchComponent}
                dateTime={searchObject.lastTime}
                onChange={e => changeDateCondition('lastTime', e)}
                format="DD/MM/YYYY HH:mm:ss"
                showTime={{ format: 'HH:mm:ss' }}
              />
            </div>
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Đơn vị kinh doanh vận tải</div>
            <Autocomplete
              freeSolo
              forcePopupIcon
              id="free-solo-2-demo"
              size="small"
              disableClearable
              disabled={isUser || isDriver}
              options={listUser || []}
              getOptionLabel={option => option?.full_name}
              value={endUserValue || ''}
              onChange={(e, value) => {
                setAgencyError(false);
                changeSearchCondition('agencyId', value);
              }}
              classes={{ option: classes.option }}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponent}
                  error={agencyError}
                  helperText={
                    agencyError
                      ? 'Vui lòng chọn đơn vị kinh doanh vận tải trước'
                      : ''
                  }
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: '16px',
                      padding: 0,
                      paddingLeft: 8
                    },
                    endAdornment: (
                      <>
                        {Number(searchObject.agencyId) > 0 && isAdmin && (
                          <InputAdornment
                            position="end"
                            style={{ cursor: 'pointer', paddingRight: '38px' }}
                            onClick={handleClearAgency}
                          >
                            <SvgIcon fontSize="small" color="action">
                              <ClearIcon />
                            </SvgIcon>
                          </InputAdornment>
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    )
                  }}
                  variant="outlined"
                />
              )}
            />
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Biển số</div>
            <Autocomplete
              multiple
              id="license-plates-multi-select"
              size="small"
              options={licensePlateOptions || []}
              value={searchObject.licensePlates || []}
              onChange={handleLicensePlateChange}
              disableCloseOnSelect
              classes={{ option: classes.option }}
              getOptionLabel={option => option}
              renderOption={(option, { selected }) => {
                const isSelectAll = option === 'Chọn tất cả';
                return (
                  <div
                    className={classes.optionItem}
                    onClick={isSelectAll ? handleSelectAll : undefined}
                    style={
                      isSelectAll
                        ? {
                          cursor: 'pointer',
                          fontWeight: 600,
                          color: '#1976d2'
                        }
                        : {}
                    }
                  >
                    <div className={classes.checkboxWrapper}>
                      <input
                        type="checkbox"
                        checked={isSelectAll ? allSelected : selected}
                        className={classes.checkbox}
                        readOnly
                      />
                      <span className={classes.optionText}>{option}</span>
                    </div>
                  </div>
                );
              }}
              renderTags={(value, getTagProps) => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    maxWidth: '100%',
                    maxHeight: '32px'
                  }}
                >
                  {value
                    .filter(option => option !== 'Chọn tất cả')
                    .map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        size="small"
                        {...getTagProps({ index })}
                        className={classes.chip}
                      />
                    ))}
                </div>
              )}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponentMulti}
                  error={licensePlateError}
                  helperText={
                    licensePlateError ? 'Vui lòng chọn ít nhất một biển số xe' : ''
                  }
                  placeholder={
                    (searchObject.licensePlates || []).filter(
                      option => option !== 'Chọn tất cả'
                    ).length === 0
                      ? 'Tất cả biển số'
                      : ''
                  }
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      height: '32px',
                      fontSize: '14px',
                      padding: '0px 8px'
                    }
                  }}
                  variant="outlined"
                />
              )}
            />
          </div>

          <div className={classes.searchItem}>
            <div className={classes.label}>Chọn điểm đi qua</div>
            <Autocomplete
              multiple
              id="safe-zones-multi-select"
              size="small"
              disabled={!hasSelectedLicensePlates}
              options={safeZoneOptions || []}
              value={selectedSafeZoneOptions}
              onChange={handleSafeZoneChange}
              disableCloseOnSelect
              classes={{ option: classes.option }}
              getOptionLabel={option => option?.nameSafeZone || ''}
              getOptionSelected={(option, value) => option.id === value.id}
              renderOption={(option, { selected }) => {
                const isSelectAll = option.id === 'all';
                return (
                  <div
                    className={classes.optionItem}
                    onClick={isSelectAll ? handleSelectAllSafeZones : undefined}
                    style={
                      isSelectAll
                        ? {
                          cursor: 'pointer',
                          fontWeight: 600,
                          color: '#1976d2'
                        }
                        : {}
                    }
                  >
                    <div className={classes.checkboxWrapper}>
                      <input
                        type="checkbox"
                        checked={isSelectAll ? allSafeZonesSelected : selected}
                        className={classes.checkbox}
                        readOnly
                      />
                      <span className={classes.optionText}>
                        {option?.nameSafeZone}
                      </span>
                    </div>
                  </div>
                );
              }}
              renderTags={(value, getTagProps) => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    maxWidth: '100%',
                    maxHeight: '32px'
                  }}
                >
                  {value.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={option.nameSafeZone}
                      size="small"
                      {...getTagProps({ index })}
                      className={classes.chip}
                    />
                  ))}
                </div>
              )}
              renderInput={params => (
                <TextField
                  {...params}
                  required={true}
                  className={classes.searchComponentMulti}
                  placeholder={
                    !hasSelectedLicensePlates
                      ? 'Vui lòng chọn biển số trước'
                      : (searchObject.checkpointZoneIdValue || []).length === 0
                        ? 'Tất cả điểm'
                        : ''
                  }
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      height: '32px',
                      fontSize: '14px',
                      padding: '0px 8px'
                    }
                  }}
                  variant="outlined"
                />
              )}
            />
          </div>

          <div className={classes.btnSearch}>
            <Button
              type="button"
              variant="contained"
              className={classes.btnStyle}
              onClick={() => searchFunction()}
            >
              Tìm kiếm
            </Button>
          </div>
        </div>
      </div>

      <div className={classes.actionHead}>
        <img
          alt="print image"
          className={classes.image}
          src="/static/images/print.svg"
        // onClick={() => downloadFile()}
        />

        <img
          alt="Excel image"
          className={classes.image}
          src="/static/images/Excel.svg"
          onClick={() => !isExporting && downloadFile()}
          style={{
            opacity: isExporting ? 0.5 : 1,
            cursor: isExporting ? 'not-allowed' : 'pointer'
          }}
        />
        {isExporting && (
          <CircularProgress size={24} className={classes.loadingIcon} />
        )}
      </div>

      <div className={classes.dataTable}>
        <TableContainer className={classes.tableContainer}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
            stickyHeader
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {sortedData &&
                sortedData.length > 0 &&
                sortedData.map((row, index) => {
                  return (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.id || row.licensePlate || index}
                    >
                      <StyledTableCell>
                        {(searchObject.page - 1) * searchObject.pageSize +
                          index +
                          1}
                      </StyledTableCell>
                      {headCells.map(headCell => (
                        <StyledTableCell
                          key={headCell.id}
                          style={
                            rightAlignedColumns.includes(headCell.id)
                              ? { textAlign: 'right' }
                              : undefined
                          }
                        >
                          {getCellValue(row, headCell.id)}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        {!sortedData || sortedData.length < 1 ? (
          <HistoryEmptyOrError
            error={historyError}
            onRetry={() => dispatch(reportBusinessLine(historyError.arg))}
            emptyClassName={classes.bottomTableError}
          />
        ) : null}

        <Backdrop className={classes.backdrop} open={isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>

        {sortedData && sortedData.length > 0 && (
          <div className={classes.pagination}>
            <Pagination
              count={totalPages}
              page={searchObject.page}
              onChange={(_, value) => handlePageChange(value)}
              color="primary"
              shape="rounded"
              showFirstButton
              showLastButton
              siblingCount={2}
              boundaryCount={1}
              classes={{
                root: classes.paginationRoot
              }}
            />
          </div>
        )}
      </div>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    backgroundColor: 'white',
    flexDirection: 'column'
  },
  titleHeader: {
    width: '100%',
    height: '36px',
    color: '#0C1132',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: '16px',
    fontSize: '20px'
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '16px'
  },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    marginBottom: '20px',
    marginLeft: '5px',
    gap: '12px'
  },
  searchItem: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 0
  },
  label: {
    marginRight: '20px',
    marginBottom: '12px',
    fontSize: '14px',
    color: '#858C93'
  },
  searchComponent: {
    width: '250px',
    height: '38px',
    '& .MuiOutlinedInput-root': {
      height: '38px',
      '& fieldset': {
        top: 0
      }
    }
  },
  searchComponentMulti: {
    width: '250px',
    maxWidth: '250px',
    position: 'relative',
    '& .MuiOutlinedInput-root': {
      flexWrap: 'nowrap',
      overflow: 'hidden',
      minHeight: '38px',
      maxHeight: '38px',
      paddingTop: '4px',
      paddingBottom: '4px',
      backgroundColor: '#fafafa',
      '& fieldset': {
        top: 0,
        borderRadius: '4px'
      }
    },
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap',
      padding: '2px 4px',
      overflow: 'hidden'
    },
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      top: '38px',
      left: 0,
      marginLeft: '12px',
      whiteSpace: 'nowrap'
    }
  },
  timeComponent: {
    marginRight: '4px',
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '80px'
    }
  },
  dateComponent: {
    '& .MuiOutlinedInput-root': {
      height: '30px',
      width: '250px'
    }
  },
  btnSearch: {
    width: '150px',
    height: '40px',
    marginLeft: '0'
  },
  btnDownload: {
    width: '100px',
    marginLeft: 'auto'
  },
  dataTable: {
    width: 'calc(100% - 40px)',
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '30px'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
  },
  wrapMenu: {
    marginTop: '30px',
    marginRight: '100px',
    marginLeft: '30px'
  },
  title: {
    color: '#3f51b5',
    cursor: 'pointer'
  },
  menuItem: {
    listStyleType: 'none',
    margin: 0,
    padding: 0
  },
  item: {
    paddingTop: '30px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '500',

    '&:hover': {
      color: '#3f51b5',
      borderBottom: '1px solid #3f51b5',
      width: 'max-content'
    }
  },
  table: {
    minWidth: 2800
  },
  tableContainer: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
    paddingRight: '8px',
    boxSizing: 'border-box',
    '&::-webkit-scrollbar': {
      height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#e4e4e4',
      borderRadius: '6px',
      '&:hover': {
        background: '#b8b8b8'
      }
    }
  },
  btnStyle: {
    padding: '10px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    width: '180px',
    height: '40px'
  },
  pagination: {
    width: '95%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: '64px',
    marginTop: '20px',
    gap: '8px'
  },
  paginationRoot: {
    '& .MuiPaginationItem-root': {
      fontSize: '14px',
      fontWeight: '500'
    },
    '& .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: 'white !important',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: `${theme.palette.primary.dark} !important`
      }
    }
  },
  actionHead: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '30px',
    backgroundColor: 'white',
    marginBottom: '5px'
  },
  bottomTableError: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginTop: '10px'
  },
  image: {
    marginRight: '10px'
  },
  loadingIcon: {
    position: 'absolute',
    right: '30px',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  option: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center'
  },
  optionItem: {
    width: '100%',
    padding: '8px 12px',
    borderBottom: '1px solid #f0f0f0',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  checkbox: {
    width: '18px',
    height: '18px',
    marginRight: '12px',
    cursor: 'pointer',
    accentColor: '#1976d2'
  },
  optionText: {
    fontSize: '14px',
    color: '#333'
  },
  chip: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    fontWeight: 500,
    borderRadius: '16px',
    margin: '4px 6px 4px 0',
    fontSize: '13px',
    height: '28px',
    '&:hover': {
      backgroundColor: '#bbdefb'
    },
    '& .MuiChip-deleteIcon': {
      color: '#1976d2',
      fontSize: '18px',
      '&:hover': {
        color: '#d32f2f'
      }
    }
  },
  deleteIcon: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1976d2',
    '&:hover': {
      color: '#d32f2f'
    }
  },
  // Responsive styles
  '@media (max-width: 1400px)': {
    searchComponent: {
      width: '240px'
    },
    searchComponentMulti: {
      width: '240px',
      maxWidth: '240px'
    }
  },
  '@media (max-width: 1200px)': {
    searchComponent: {
      width: '220px'
    },
    searchComponentMulti: {
      width: '220px',
      maxWidth: '220px'
    },
    btnSearch: {
      width: '120px'
    }
  },
  '@media (max-width: 992px)': {
    searchRow: {
      gap: '8px',
      marginRight: '16px'
    },
    searchItem: {
      minWidth: '45%'
    }
  }
}));

export default BusinessLineReport;
